import { Badge, type BadgeProps } from "./badge";
import { X } from "lucide-react";

export interface DeletableBadgeProps extends BadgeProps {
  onDelete?: () => void;
  disabled?: boolean;
}

export const DeletableBadge = ({
  children,
  onDelete,
  disabled = false,
  variant = "secondary",
  ...props
}: DeletableBadgeProps) => (
  <Badge variant={variant} {...props}>
    {children}
    {onDelete && (
      <button
        onClick={disabled ? undefined : onDelete}
        disabled={disabled}
        className="ml-1 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label={`Remove ${children}`}
      >
        <X className="h-2.5 w-2.5" />
      </button>
    )}
  </Badge>
);
